"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), 'Network');
